module.exports = __webpack_public_path__ + "static/media/graph4.abcff985.svg";